export default __webpack_public_path__ + "static/media/task.2a45ee8c.svg";